"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Table = _interopRequireDefault(require("../../../preact-components/table/Table"));

var _axios = _interopRequireDefault(require("axios"));

var _Loader = require("../Loader");

var _EmptyTable = _interopRequireDefault(require("../EmptyTable"));

var _EmptyResults = require("../EmptyResults");

var _assets = _interopRequireDefault(require("../../../preact-components/assets"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DEFAULT_PAGE = 1;
var DEFAULT_PAGE_SIZE = 25;
var PAGINATION_STORAGE_KEY = 'companyIdeasTablePagination';

function saveSessionPagination(page, pageSize) {
  var item = window.sessionStorage.getItem(PAGINATION_STORAGE_KEY);
  var storage = item ? JSON.parse(item) : {};
  storage.pagination = {
    page: page,
    pageSize: pageSize
  };
  window.sessionStorage.setItem(PAGINATION_STORAGE_KEY, JSON.stringify(storage));
}

var CompanyIdeasTable = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CompanyIdeasTable, _Component);

  var _super = _createSuper(CompanyIdeasTable);

  function CompanyIdeasTable(props) {
    var _this;

    (0, _classCallCheck2.default)(this, CompanyIdeasTable);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ideaStatuses", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageChange", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(page) {
        var _this$state$paginatio;

        var pageSize;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                pageSize = (_this$state$paginatio = _this.state.pagination.pageSize) !== null && _this$state$paginatio !== void 0 ? _this$state$paginatio : DEFAULT_PAGE_SIZE;

                _this.updatePagination(page, pageSize);

                _context.next = 4;
                return _this.fetchIdeas();

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPageSizeChange", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(pageSize) {
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.updatePagination(DEFAULT_PAGE, pageSize);

                _context2.next = 3;
                return _this.fetchIdeas();

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x2) {
        return _ref2.apply(this, arguments);
      };
    }());
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "updatePagination", function (page, pageSize) {
      _this.setState(function (prevState) {
        return {
          pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
            page: page,
            pageSize: pageSize
          })
        };
      });

      saveSessionPagination(page, pageSize);
    });
    var ideaStatuses = props.ideaStatuses;
    _this.ideaStatuses = ideaStatuses.reduce(function (prev, curr) {
      prev[curr.id] = curr;

      if (curr.default) {
        prev.default = curr;
      }

      return prev;
    }, {});

    _this.setState({
      ideas: [],
      sorting: {
        order: 'updated_at',
        direction: 'desc'
      },
      isLoading: true,
      isPaginationSet: false,
      pagination: {
        page: DEFAULT_PAGE,
        pageSize: DEFAULT_PAGE_SIZE,
        total: undefined
      },
      total: undefined
    });

    _this.onPageChange = _this.onPageChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPageSizeChange = _this.onPageSizeChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.updatePagination = _this.updatePagination.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(CompanyIdeasTable, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.fetchIdeas();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchIdeas",
    value: function () {
      var _fetchIdeas = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4() {
        var _this$state, sorting, pagination, res;

        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                this.setState({
                  isLoading: true
                });
                _this$state = this.state, sorting = _this$state.sorting, pagination = _this$state.pagination;
                _context4.prev = 2;
                _context4.next = 5;
                return _axios.default.post('/analyticsV2/fetchCompanyIdeas', {
                  company_id: this.props.companyId,
                  page: pagination.page,
                  pageSize: pagination.pageSize,
                  sortOrder: sorting.order,
                  sortDirection: sorting.direction
                });

              case 5:
                res = _context4.sent;
                this.setState(function (prevState) {
                  return _objectSpread(_objectSpread({}, prevState), {}, {
                    ideas: res.data.ideas,
                    total: res.data.total,
                    isLoading: false,
                    pagination: _objectSpread(_objectSpread({}, prevState.pagination), {}, {
                      total: res.data.total
                    })
                  });
                });

              case 7:
                _context4.prev = 7;
                this.setState({
                  isLoading: false
                });
                return _context4.finish(7);

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[2,, 7, 10]]);
      }));

      function fetchIdeas() {
        return _fetchIdeas.apply(this, arguments);
      }

      return fetchIdeas;
    }()
  }, {
    key: "getModel",
    value: function getModel() {
      var _this2 = this;

      return [{
        header: 'Title',
        accessor: 'title',
        cell: function cell(idea) {
          return (0, _preact.h)("div", {
            className: "idea-title_company_ideas__table"
          }, (0, _preact.h)("span", null, idea.title), ' ', (0, _preact.h)("a", {
            href: (0, _absoluteUrlRuntime.resolveUrl)("/idea/".concat(idea.id)),
            target: "_blank",
            rel: "noreferrer"
          }, (0, _preact.h)(_assets.default, {
            icon: "externalLink",
            width: 16,
            height: 16
          })));
        },
        size: 'm'
      }, {
        header: 'Status',
        accessor: 'status',
        cell: function cell(idea) {
          var _this2$ideaStatuses$i, _this2$ideaStatuses$i2, _this2$ideaStatuses$i3;

          return (0, _preact.h)("span", {
            className: (0, _classnames.default)('pill', 'pill_idea', 'pill--uppercase'),
            style: {
              color: "#".concat(((_this2$ideaStatuses$i = _this2.ideaStatuses[idea.status]) === null || _this2$ideaStatuses$i === void 0 ? void 0 : _this2$ideaStatuses$i.textColor) || _this2.ideaStatuses.default.textColor),
              backgroundColor: "#".concat(((_this2$ideaStatuses$i2 = _this2.ideaStatuses[idea.status]) === null || _this2$ideaStatuses$i2 === void 0 ? void 0 : _this2$ideaStatuses$i2.backgroundColor) || _this2.ideaStatuses.default.backgroundColor)
            }
          }, ((_this2$ideaStatuses$i3 = _this2.ideaStatuses[idea.status]) === null || _this2$ideaStatuses$i3 === void 0 ? void 0 : _this2$ideaStatuses$i3.name) || _this2.ideaStatuses.default.name);
        },
        size: 'right',
        sorting: 'status_id'
      }, {
        header: 'Votes',
        accessor: 'votes',
        cell: function cell(idea) {
          return (0, _preact.h)("span", {
            className: "idea-votes_company_ideas__table"
          }, idea.votes, " ", (0, _preact.h)(_assets.default, {
            icon: "triangle",
            width: 10,
            height: 10
          }));
        },
        size: 'right',
        sorting: 'total_votes'
      }, {
        header: 'Submitted at',
        accessor: 'submittedAt',
        size: 'right',
        sorting: 'submitted_at'
      }, {
        header: 'Last activity',
        accessor: 'updatedAt',
        size: 'right',
        sorting: 'updated_at'
      }, {
        header: 'Type',
        accessor: 'submitted',
        cell: function cell(idea) {
          return idea.submitted ? 'submitted' : 'upvoted';
        },
        size: 'right',
        sorting: 'submitted'
      }];
    }
  }, {
    key: "getPaginationOptions",
    value: function getPaginationOptions() {
      var pagination = this.state.pagination;

      if (pagination === undefined) {
        return undefined;
      }

      var total = pagination.total;

      if (total !== undefined && total > 25) {
        return {
          pagination: _objectSpread(_objectSpread({}, pagination), {}, {
            total: total
          }),
          onPageChange: this.onPageChange,
          onPageSizeChange: this.onPageSizeChange
        };
      }

      return undefined;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var isSalesforceIntegrationEnabled = this.props.isSalesforceIntegrationEnabled;
      var _this$state2 = this.state,
          ideas = _this$state2.ideas,
          sorting = _this$state2.sorting,
          isLoading = _this$state2.isLoading;

      if (!isSalesforceIntegrationEnabled) {
        return (0, _preact.h)("div", {
          className: "dashboard-table-wrapper no-data"
        }, (0, _preact.h)("div", {
          className: "data-not-tracked-text"
        }, "There\u2019s no data yet"));
      }

      if (isLoading) {
        return (0, _preact.h)("div", {
          className: "dashboard-table-wrapper"
        }, (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel()
        }, (0, _preact.h)(_Loader.Loader, {
          parentCustomClass: "dashboard-table-loader"
        })));
      }

      if (ideas.length === 0) {
        return (0, _preact.h)("div", {
          className: "dashboard-table-wrapper"
        }, (0, _preact.h)(_EmptyTable.default, {
          model: this.getModel()
        }, (0, _preact.h)(_EmptyResults.EmptyResults, null)));
      }

      return (0, _preact.h)("div", {
        className: "dashboard-table-wrapper"
      }, (0, _preact.h)(_Table.default, {
        model: this.getModel(),
        rows: ideas,
        classes: ['active_customers__table'],
        onSortChange: function onSortChange(attr) {
          var newSorting;

          if (sorting && sorting.order === attr) {
            newSorting = {
              order: attr,
              direction: sorting.direction === 'asc' ? 'desc' : 'asc'
            };
          } else {
            newSorting = {
              order: attr,
              direction: 'desc'
            };
          }

          _this3.setState({
            sorting: newSorting
          });

          _this3.fetchIdeas();
        },
        sort: sorting,
        withPagination: this.getPaginationOptions(),
        actionElements: (0, _preact.h)("div", {
          className: "title-company_ideas__table"
        }, "Ideas the company has participated in")
      }));
    }
  }]);
  return CompanyIdeasTable;
}(_preact.Component);

var _default = CompanyIdeasTable;
exports.default = _default;